<template>
  <div v-if="!renewingToken" class="ly-col ly-center-center reset-password-container">
    <img src="@/assets/img/lp-logo-white.svg" class="mb-3" />
    <div class="card">
      <h3>Your session will expire in: {{ countdownText }}</h3>
      <p>Do you want to renew the session?</p>
      <lp-button @click="refreshToken" type="primary">Renew</lp-button>
      <lp-button @click="cancelRefresh">Cancel</lp-button>
    </div>
  </div>

  <div v-if="renewingToken" class="ly-col ly-center-center reset-password-container">
    <img src="@/assets/img/lp-logo-white.svg" class="mb-3" />
    <div class="card">
      <h3>Your session is being refreshed. Please wait</h3>
    </div>
  </div>
</template>

<script setup lang="ts">

import { ref, Ref, onMounted, inject } from 'vue'
import { useConfig } from '@/config/useConfig'
import { Redirect } from '@/types/redirect'

const postMessageToParentWindow = inject('postMessageToParentWindow') as (message: object, target: string) => void
const redirect = inject('redirect') as Redirect
const getQueryParameter = inject('getQueryParameter') as (paramName: string) => string
const countdownText: Ref<string> = ref('')
const renewingToken: Ref<boolean> = ref(false)
const triggerRefreshTokenOnLoad = true
// in minutes
let countDownCurrent: number
let setIntervalReference: number

const updateCountdown = async () => {
  if (countDownCurrent === undefined) countDownCurrent = getSecondsToRefreshToken(getQueryParameter('accessToken'))
  let minutes = Math.floor(countDownCurrent / 60)
  let seconds = Math.floor(countDownCurrent % 60)

  minutes = minutes < 10 ? 0 + minutes : minutes
  seconds = seconds < 10 ? 0 + seconds : seconds

  const leftMessage = `00${minutes}`
  const rightMessage = `00${seconds}`

  countdownText.value = leftMessage.substring(leftMessage.length - 2) + ':' + rightMessage.substring(rightMessage.length - 2)

  countDownCurrent--

  if (countDownCurrent < 0) {
    await timerEnded()
  }
}

const timerEnded = async () => {
  clearInterval(setIntervalReference)
  const config = await useConfig()
  postMessageToParentWindow({ eventName: 'timeEnded' }, config.sso.lms_url)
}

const cancelRefresh = async () => {
  const config = await useConfig()
  postMessageToParentWindow({ eventName: 'refreshCanceled' }, config.sso.lms_url)
}

const refreshToken = async () => {
  const config = await useConfig()
  renewingToken.value = true
  clearInterval(setIntervalReference)
  redirect(`${config.api.url}${config.api.service_path}/auth/refreshToken`, true)
}

const init = async () => {
  if (triggerRefreshTokenOnLoad) {
    refreshToken()
  } else {
    await updateCountdown()
    setIntervalReference = setInterval(updateCountdown, 1000)
  }
}

onMounted(init)

const getSecondsToRefreshToken = (token: string) => {
  const payload = parseJwt(token)
  const refreshTokenTimeWindow = 60000 * 2
  const milisecondsToRefreshToken = (payload.exp * 1000) - refreshTokenTimeWindow - Date.now()
  const seconds = Math.floor(milisecondsToRefreshToken / 1000)
  return seconds < 1 ? 1 : seconds
}

const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
  return JSON.parse(jsonPayload)
}

</script>

<style>
.form-reset-password {
  padding: 0px;
  margin: 0px;
}

.reset-password-container {
  height: 100%;
  background: #354255;
}

.reset-password-container .card {
  width: 550px;
}

.reset-password-container img {
  width: 200px;
}
</style>
